// extracted by mini-css-extract-plugin
export default {"stosks_column":"styles_stosks_column__zr1nn","link_download":"styles_link_download__6f-cf","main_block":"styles_main_block__hsjpc","text_time":"styles_text_time__6f1wH"};